module.exports = __webpack_public_path__ + "static/media/image-992.1aa4a0ea.webp";